import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/showinfos')({
  beforeLoad: () => {
    throw redirect({ to: '/demoinfo' })
  },
})
